import React, { useContext, useEffect, useState, memo } from 'react'
import { useTranslation } from 'react-i18next'
import OptionsContext from '../../utils/OptionsContext'
import VoiceoverButton from '../VoiceoverButton/VoiceoverButton'

const TextWithVoiceover = ({ textKey, color }) => {
  const { t } = useTranslation()
  const { hasVoiceover } = useContext(OptionsContext)
  const [hasAudio, setHasAudio] = useState(null)

  const soundKey = textKey.replace(/:/g, '-').toLowerCase()

  useEffect(() => {
    ;(async function () {
      const hasAudio = await hasVoiceover(soundKey)
      setHasAudio(hasAudio)
    })()
  }, [soundKey, hasVoiceover])

  return (
    <>
      {hasAudio === null && (
        <span
          style={{ width: '25px', height: '25px', display: 'inline-block' }}
        />
      )}
      {hasAudio !== null && hasAudio && (
        <VoiceoverButton path={soundKey} color={color} />
      )}
      {t(textKey)}
    </>
  )
}

export default memo(TextWithVoiceover)
